<template>
  <div class="add-box">
    <el-button type="text" :disabled="loading" @click="loadDetail">
      <slot></slot>
    </el-button>

    <el-drawer
        title="修改"
        :visible.sync="openStatus"
        direction="rtl"
        size="90%"
        :append-to-body="true"
        :close-on-press-escape="false"
        :destroy-on-close="true"
        :wrapperClosable="false"
        :before-close="closeHandle"
    >
      <el-row>
        <el-col :span="12" :offset="6">
          <validation-observer ref="observer" v-slot="{ handleSubmit }">
            <el-form label-width="100px">
              <el-row>

                <el-col :span="24">
                  <validation-provider rules="required" name="ICCID" v-slot="{ errors }">
                    <el-form-item label="ICCID" :error="errors[0]">
                      <el-input v-model="form.iccid" clearable placeholder="请填写ICCID"></el-input>
                    </el-form-item>
                  </validation-provider>
                </el-col>

                <el-col :span="12">
                  <validation-provider rules="required" name="卡号" v-slot="{ errors }">
                    <el-form-item label="卡号" :error="errors[0]">
                      <el-input v-model="form.card_number" clearable placeholder="请填写卡号"></el-input>
                    </el-form-item>
                  </validation-provider>
                </el-col>

                <el-col :span="12">
                  <el-form-item label="设备唯一码">
                    <el-input v-model="form.device_unique" clearable placeholder="请填写设备唯一码"></el-input>
                  </el-form-item>
                </el-col>

                <el-col :span="12">
                  <el-form-item label="inst">
                    <el-input v-model="form.inst" clearable placeholder="请填写inst"></el-input>
                  </el-form-item>
                </el-col>

                <el-col :span="12">
                  <el-form-item label="imei">
                    <el-input v-model="form.imei" clearable placeholder="请填写imei"></el-input>
                  </el-form-item>
                </el-col>

                <el-col :span="12">
                  <el-form-item label="pin1">
                    <el-input v-model="form.pin1" clearable placeholder="请填写pin1"></el-input>
                  </el-form-item>
                </el-col>

                <el-col :span="12">
                  <el-form-item label="pin2">
                    <el-input v-model="form.pin2" clearable placeholder="请填写pin2"></el-input>
                  </el-form-item>
                </el-col>

                <el-col :span="12">
                  <el-form-item label="puk1">
                    <el-input v-model="form.puk1" clearable placeholder="请填写puk1"></el-input>
                  </el-form-item>
                </el-col>

                <el-col :span="12">
                  <el-form-item label="puk2">
                    <el-input v-model="form.puk2" clearable placeholder="请填写puk2"></el-input>
                  </el-form-item>
                </el-col>

                <el-col :span="24">
                  <el-form-item label="备注">
                    <el-input v-model="form.whither" clearable placeholder="请填写备注信息"></el-input>
                  </el-form-item>
                </el-col>

                <el-col :span="24">
                  <el-form-item label="激活时间">
                    <el-date-picker
                        v-model="form.active_at"
                        type="date"
                        placeholder="选择激活时间"
                        value-format="yyyy-MM-dd"
                    >
                    </el-date-picker>
                  </el-form-item>
                </el-col>

                <el-col :span="24">
                  <el-form-item label="到期时间">
                    <el-date-picker
                        v-model="form.expire_at"
                        type="date"
                        placeholder="选择到期时间"
                        value-format="yyyy-MM-dd"
                    >
                    </el-date-picker>
                  </el-form-item>
                </el-col>

                <el-col :span="24">
                  <el-form-item>
                    <el-button type="primary" :disabled="submitIng" @click="handleSubmit(onSubmit)">
                      {{ submitIng ? '提交中...' : '提交' }}
                    </el-button>
                    <el-button @click="closeHandle">取消</el-button>
                  </el-form-item>
                </el-col>

              </el-row>
            </el-form>
          </validation-observer>
        </el-col>
      </el-row>
    </el-drawer>

  </div>
</template>

<script>

import {mapState} from "vuex";

export default {
  components: {},
  data() {
    return {
      user: {},
      loading: false,
      query: {
        id: '',
      },
      detail: {},
      form: {
        id: '',
        iccid: '',
        card_number: '',
        device_unique: '',
        inst: '',
        imei: '',
        pin1: '',
        pin2: '',
        puk1: '',
        puk2: '',
        usage: '',
        active_at: '',
        expire_at: '',
        whither: '',
      },
      submitIng: false,
      openStatus: false,
    };
  },
  computed: mapState({
    config: (state) => state.config,
  }),
  props: {
    param: {
      type: Object,
      default: () => {
        return {
          id: ''
        };
      }
    }
  },
  mounted() {},
  methods: {
    loadDetail() {
      const _this = this;
      _this.loading = true;
      _this.form = {
        id: '',
        iccid: '',
        card_number: '',
        device_unique: '',
        inst: '',
        imei: '',
        pin1: '',
        pin2: '',
        puk1: '',
        puk2: '',
        usage: '',
        active_at: '',
        expire_at: '',
        whither: '',
      }
      _this.query.id = _this.param.id;
      _this.$apiAdmin.adminSimUpdateDetail(_this.query)
          .then(res => {
            _this.openStatus = true;
            _this.loading = false;
            _this.detail = res.detail;
            _this.form = JSON.parse(JSON.stringify(res.detail))
          })
          .catch(err => {
            _this.loading = false;
            _this.openStatus = false;
          })
    },
    onSubmit() {
      const _this = this;
      _this.submitIng = true;
      _this.form.id = _this.query.id;
      _this.$apiAdmin.adminSimUpdate(_this.form)
          .then((res) => {
            _this.submitIng = false;
            _this.closeHandle();
            _this.$message.success('修改成功')
            _this.$emit('finish', res)
          })
          .catch(err => {
            _this.submitIng = false;
            _this.$message.error(err.msg)
          })
    },
    closeHandle() {
      const _this = this;
      _this.openStatus = false;
      _this.form = {
        id: '',
        iccid: '',
        card_number: '',
        device_unique: '',
        inst: '',
        imei: '',
        pin1: '',
        pin2: '',
        puk1: '',
        puk2: '',
        usage: '',
        active_at: '',
        expire_at: '',
        whither: '',
      }
    }
  }
}
</script>

<style scoped>
.add-box {
  padding-right: 10px;
}
</style>